import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  class: "fs13 mt10 w100 pad10 with_white_bg",
  style: {"line-height":"1.4"}
}
const _hoisted_3 = {
  key: 0,
  href: "https://help.waaq.jp/page_create/2315/",
  target: "_blank",
  class: "underline fw600 orange"
}
const _hoisted_4 = {
  key: 1,
  href: "https://help.waaq.jp/page_create/3270/",
  target: "_blank",
  class: "underline fw600 orange"
}
const _hoisted_5 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`with_white_bg`)
}
const _hoisted_6 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`llgreyBg rad8 pad20`)
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "fl mr10 fw600" }, "送信する", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { class: "w100" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "fl fw600 mt30 mr10" }, "イベント開始", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt30 fw600" }, "分後に送信", -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { class: "fl mt10 mr20" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "fs13 fw600" }, "送信先", -1)
const _hoisted_18 = ["for"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`llgreyBg rad8 pad20`)
}
const _hoisted_22 = { class: "w100" }
const _hoisted_23 = { class: "fw600 mt30 mr10 fs16" }
const _hoisted_24 = { class: "fs13 fw600" }
const _hoisted_25 = { class: "fl" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = {
  key: 0,
  class: "fs11 fw600"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = {
  key: 2,
  class: "mt20 ml10"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "fl mr10 fw600" }, "お相手に回答内容を表示する", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = {
  key: 3,
  class: "mt20 ml10"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "fl mr10 fw600" }, "調整ページへのボタンを表示する", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`llgreyBg rad8 pad20`)
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "fl mr10 fw600" }, "送信する", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_SpanSlotContent = _resolveComponent("SpanSlotContent")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_AddCommentToMail = _resolveComponent("AddCommentToMail")!
  const _component_IconHelp = _resolveComponent("IconHelp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.rcm.selectedMailFlow)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: _normalizeClass(`${_ctx.isSP ? `` : ``} mt10`)
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.getDescription) + " ", 1),
            ([`feedback`].includes(_ctx.rcm.selectedMailFlow.def_type))
              ? (_openBlock(), _createElementBlock("a", _hoisted_3, "送信タイミングの詳細はこちらをご確認ください"))
              : (_openBlock(), _createElementBlock("a", _hoisted_4, "送信タイミングの詳細はこちらをご確認ください"))
          ]),
          (_ctx.rcm.selectedMailFlow.is_active)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                ([`feedback`, `custom`].includes(_ctx.rcm.selectedMailFlow.def_type))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", null, [
                        _hoisted_7,
                        _createVNode(_component_Switcher, {
                          value: "type[active]",
                          name: "無効",
                          checked: _ctx.rcm.selectedMailFlow.is_active,
                          display: "true",
                          class: "checkUsingCal fl",
                          onSelect: _ctx.changeActiveMailFlow
                        }, null, 8, ["checked", "onSelect"]),
                        _hoisted_8
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        ([`feedback`].includes(_ctx.rcm.selectedMailFlow.def_type))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _hoisted_11,
                              _createVNode(_component_MdTextfieldTag, {
                                style: {"height":"56px","min-width":"60px","width":"60px"},
                                fieldStyle: `min-width:60px;font-size:20px;`,
                                class: "fs20 fl",
                                value: _ctx.rcm.selectedMailFlow.send_timing || 0,
                                type: "number",
                                min: 0,
                                max: 999,
                                onInputValue: _ctx.inputSendTiming,
                                onBlur: _ctx.checkSendTiming,
                                required: ""
                              }, null, 8, ["value", "onInputValue", "onBlur"]),
                              _hoisted_12
                            ]))
                          : ([`custom`].includes(_ctx.rcm.selectedMailFlow.def_type))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createVNode(_component_SelectTag, {
                                  name: "custom_send_timing",
                                  id: "custom_send_timing",
                                  class: "fl fs14 roundForm mt20",
                                  style: {"max-width":"200px","height":"50px"},
                                  options: _ctx.SelectUtil.selectMailFlowTimingTypes.map(tt => tt.name),
                                  defaultOption: _ctx.defaultTimingTypeText,
                                  needUnselect: false,
                                  onSelectValue: _ctx.selectTimingType
                                }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                                _hoisted_14,
                                _createVNode(_component_SpanSlotContent, {
                                  mins: _ctx.rcm.selectedMailFlow.send_timing || 0,
                                  min: 0,
                                  max: 144000,
                                  afterText: ` `,
                                  onUpdateSpan: _ctx.updateCustomTimingMin
                                }, null, 8, ["mins", "onUpdateSpan"]),
                                _createVNode(_component_SelectTag, {
                                  name: "custom_send_timing",
                                  id: "custom_send_timing",
                                  class: "fl fs14 roundForm mt15",
                                  style: {"max-width":"130px","height":"50px"},
                                  options: [`前に送信`, `後に送信`],
                                  defaultOption: _ctx.rcm.selectedMailFlow.send_timing_around == `before` ? `前に送信` : `後に送信`,
                                  onSelectValue: _ctx.selectAvailableSpan
                                }, null, 8, ["defaultOption", "onSelectValue"]),
                                _hoisted_15,
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_16, [
                                    _hoisted_17,
                                    _createElementVNode("div", {
                                      class: "pointer fs12 skyblue",
                                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkAllSendTo && _ctx.checkAllSendTo(...args)))
                                    }, "すべてにチェック")
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SelectUtil.selectMailFlowSendToTypes, (sendto, sendtoindex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: `${sendto}_${sendtoindex}_${_ctx.rcm.selectedMailFlow.send_to}`,
                                      class: "fl",
                                      style: {"width":"200px"}
                                    }, [
                                      _createVNode(_component_CheckboxTag, {
                                        value: sendto.type,
                                        name: sendto.type,
                                        checked: 
                                            _ctx.rcm.selectedMailFlow.send_to.includes(`all`) ||
                                            _ctx.rcm.selectedMailFlow.send_to.includes(sendto.type)
                                        ,
                                        prefix: `send_to`,
                                        onClickCheckbox: _ctx.clickSendTo
                                      }, null, 8, ["value", "name", "checked", "onClickCheckbox"]),
                                      _createTextVNode("   "),
                                      _createElementVNode("label", {
                                        for: `send_to_${sendto.type}`,
                                        class: "fs12 fw600"
                                      }, _toDisplayString(sendto.name), 9, _hoisted_18)
                                    ]))
                                  }), 128)),
                                  _hoisted_19
                                ])
                              ]))
                            : _createCommentVNode("", true)
                      ]),
                      _hoisted_20
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_AddCommentToMail, {
                  ref: "AddCommentToMail",
                  class: "mt20",
                  tmp: _ctx.tmp,
                  showSubject: true,
                  onInputMemo: _ctx.inputMemo,
                  onInputSubject: _ctx.inputSubject,
                  onInputSmsContent: _ctx.inputSmsContent
                }, null, 8, ["tmp", "onInputMemo", "onInputSubject", "onInputSmsContent"]),
                ([`feedback`, `custom`].includes(_ctx.rcm.selectedMailFlow.def_type))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createTextVNode(" ボタンを編集 "),
                          _createVNode(_component_IconHelp, {
                            width: 18,
                            tooltipText: `ボタンを設置する場合、リンク先を入力するか、アンケートで利用する公開ページなどを紐付けてください。\n
                                どちらも入力した場合、紐付けた公開ページが優先されます。`,
                            style: {"margin-top":"-3px","margin-right":"5px"}
                          })
                        ]),
                        _createVNode(_component_MdTextfieldTag, {
                          name: "ボタン名",
                          fieldStyle: "min-width:250px;max-width:250px;",
                          style: {"height":"56px","min-width":"250px"},
                          class: "fs16",
                          value: _ctx.rcm.selectedMailFlow.button_name,
                          onInputValue: _ctx.inputButtonName,
                          required: ""
                        }, null, 8, ["value", "onInputValue"]),
                        _createVNode(_component_MdTextfieldTag, {
                          name: "ボタンのリンク先URL",
                          fieldStyle: "min-width:250px;max-width:250px;",
                          style: {"height":"56px","min-width":"250px"},
                          class: "fs16",
                          value: _ctx.rcm.selectedMailFlow.button_link,
                          onInputValue: _ctx.inputButtonLink,
                          required: ""
                        }, null, 8, ["value", "onInputValue"]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createTextVNode(" 公開ページを紐付ける "),
                            _createVNode(_component_IconHelp, {
                              width: 18,
                              tooltipText: `公開ページを紐付けておくと、お相手の方は重複した項目（メールアドレス・名前）への入力が不要になります。`,
                              style: {"margin-top":"-3px","margin-right":"5px"}
                            })
                          ]),
                          _createVNode(_component_MdTextfieldTag, {
                            name: "公開ページIDを入力",
                            fieldStyle: "min-width:250px;max-width:250px;",
                            style: {"height":"56px","min-width":"250px"},
                            class: "fs16 fl",
                            value: _ctx.publicId,
                            onInputValue: _ctx.inputPublicID,
                            required: ""
                          }, null, 8, ["value", "onInputValue"]),
                          _createElementVNode("div", {
                            class: "fl greyBg rad5 mt16 fs11 pointer hoverGreyBg",
                            style: {"padding":"13px","height":"40px"},
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickConnectPublicPage && _ctx.clickConnectPublicPage(...args)))
                          }, " 紐付け "),
                          _hoisted_26,
                          (_ctx.selectedRoom)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, " 「" + _toDisplayString(`[${_ctx.selectedRoom.public_id}]${
                                        _ctx.selectedRoom.appeal_content.title
                                            ? _ctx.selectedRoom.appeal_content.title
                                            : _ctx.selectedRoom.current_appointment.name
                                    }`) + "」の公開ページを紐付けています。 ", 1))
                            : _createCommentVNode("", true),
                          _hoisted_28
                        ]),
                        (_ctx.selectedRoom)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "pointer skyblue",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deselect && _ctx.deselect(...args)))
                            }, "選択をはずす"))
                          : _createCommentVNode("", true),
                        _hoisted_29
                      ]),
                      _hoisted_30
                    ]))
                  : _createCommentVNode("", true),
                (
                        [`inquire_on_public_room`, `fix`, `fixed_appointment`, `custom`].includes(
                            _ctx.rcm.selectedMailFlow.def_type
                        ) && !_ctx.rcm.showSMSField
                    )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _hoisted_32,
                      _createVNode(_component_Switcher, {
                        value: "type[show_qa]",
                        name: "有効",
                        checked: _ctx.rcm.selectedMailFlow.show_qa,
                        display: "true",
                        class: "checkUsingCal fr mr20",
                        onSelect: _ctx.changeShowQA
                      }, null, 8, ["checked", "onSelect"]),
                      _hoisted_33
                    ]))
                  : _createCommentVNode("", true),
                ([`custom`].includes(_ctx.rcm.selectedMailFlow.def_type))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _hoisted_35,
                      _createVNode(_component_Switcher, {
                        value: "type[display_link_button]",
                        name: "有効",
                        checked: _ctx.rcm.selectedMailFlow.display_parent_room_link_button,
                        display: "true",
                        class: "checkUsingCal fr mr20",
                        onSelect: _ctx.changeDisplayLinkButton
                      }, null, 8, ["checked", "onSelect"]),
                      _hoisted_36
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _hoisted_38,
                _createVNode(_component_Switcher, {
                  value: "type[active]",
                  name: "有効",
                  checked: _ctx.rcm.selectedMailFlow ? _ctx.rcm.selectedMailFlow.is_active : false,
                  display: "true",
                  class: "checkUsingCal fl",
                  onSelect: _ctx.changeActiveMailFlow
                }, null, 8, ["checked", "onSelect"]),
                _hoisted_39
              ]))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}